import { connect } from 'react-redux';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { select, showMaximizedChart, hideMaximizedChart } from '../../actions';
import {
  getCashflowCoverageData,
  getInitialAssetXSReturn,
} from './selectors';
import React from 'react';
import { Modal } from 'react-bootstrap';
import CashflowCoverageChart from '../../charts/CashflowCoverageChart';

const layouts = {
  lg: [
    { i: 'cashflow-coverage-chart', x: 0, y: 0, w: 12, h: 8, minW: 6, minH: 4 },
  ],
  xxs: [
    { i: 'cashflow-coverage-chart', x: 0, y: 0, w: 1, h: 4, static: true },
  ],
};

const ReactResponsiveGridLayout = WidthProvider(Responsive);

const Dashboard = (props) => {
  const charts = {
    cashflowCoverageChart: <CashflowCoverageChart
      isLoading={props.isLoading}
      title="Cashflow Coverage"
      data={props.cashflowCoverageChartData}
      selected={props.assetXSReturn}
      onSelected={props.onSelected}
      onViewSelected={view => props.onSelected('view', view)}
      displayOptions={['Amount', 'Present Value']}
      selectedDisplayOption={props.view}
    />,
  }

  const modalChart = props.showMaximizedChart ? React.cloneElement(
    charts[props.maximizedChart],
    { onMaximized: null, onMinimized: () => props.onMinimized() },
  ) : null;

  return (
    <div>
      <ReactResponsiveGridLayout
        className="layout"
        layouts={layouts}
        breakpoints={{ lg: 800, xxs: 0 }}
        cols={{ lg: 12, xxs: 1 }}
        rowHeight={70}
        measureBeforeMount={true}
      >
        <div key="cashflow-coverage-chart">
          {charts.cashflowCoverageChart}
        </div>
      </ReactResponsiveGridLayout>
      <div className="maximized-chart">
        <Modal show={props.showMaximizedChart} onHide={props.onMinimized} dialogClassName="maximized-chart-modal">
          {modalChart}
        </Modal>
      </div>
    </div>
  );
}

const mapStateToProps = (state, props) => {
  if (props.isLoading) {
    return {
      isLoading: true,
    };
  }

  const benefitPayments = props.data.BenefitPayments.data;
  const yearAssetsRunOut = props.data.ReturnStats.data;

  const isDataPresent = state.local.cashflow_coverage === undefined;

  const assetXSReturn = isDataPresent || state.local.cashflow_coverage.assetXSReturn === undefined ? getInitialAssetXSReturn(yearAssetsRunOut) : state.local.cashflow_coverage.assetXSReturn;
  const view = isDataPresent || state.local.cashflow_coverage.view === undefined ? 'Amount' : state.local.cashflow_coverage.view;

  const cashflowCoverageChartData = getCashflowCoverageData(benefitPayments, yearAssetsRunOut, assetXSReturn, view);
  const isLoading = false;
  const showMaximizedChart = state.local.showMaximizedChart;
  const maximizedChart = state.local.maximizedChart;

  return {
    isLoading,
    showMaximizedChart,
    maximizedChart,
    assetXSReturn,
    view,
    cashflowCoverageChartData,
  }
}

const mapDispatchToProps = ({
  onSelected: (key, value) => select(key, value, 'cashflow_coverage'),
  onMaximized: chart => showMaximizedChart(chart),
  onMinimized: hideMaximizedChart,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboards/CashflowCoverage/Dashboard.js